import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FilterTransactionsType,
  TransactionResponseTypeResult,
} from "sagas/types/transactions";
import { RootState } from "store";
import { actions as detailTransactionAction } from "reducers/detailTransaction";
import { BulkCancelTransactionType } from "../sagas/types/transactions";
import {
  GetTransactionsSuccessType,
  SetFilterType,
  TransactionStateType,
} from "./types/transaction";

export const initialState: TransactionStateType = {
  detailTransactionModalOpen: false,
  exportDisabled: true,
  transactions: [],
  transactionsSelected: [],
  errorTransactions: [],
  masiveCancelationModalOpen: false,
  filters: {
    maxSla: undefined,
    minSla: undefined,
    offset: undefined,
    state: undefined,
    regions: undefined,
    origins: undefined,
    pickerId: undefined,
    transactionCode: undefined,
    actualRegion: undefined,
  },
  offset: 0,
  seeMore: true,
  collapseTable: true,
};

const SLICE_NAME = "transaction";

export const transactionSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: (state) => {
      state = { ...initialState };
    },
    getTransactionsRequest: (
      state: TransactionStateType,
      action: PayloadAction<FilterTransactionsType>
    ) => {
      state.transactionsSelected = [];
      state.errorTransactions = [];
    },
    getMoreTransactionsRequest: (
      state: TransactionStateType,
      action: PayloadAction<FilterTransactionsType>
    ) => {},
    getTransactionsSuccess: (
      state: TransactionStateType,
      action: PayloadAction<GetTransactionsSuccessType>
    ) => {
      state.transactions = action.payload.items;
      state.seeMore = action.payload.hasMore;
      state.offset = action.payload.offset + action.payload.limit;
      state.limit = action.payload.limit;
    },
    getMoreTransactionsSuccess: (
      state: TransactionStateType,
      action: PayloadAction<GetTransactionsSuccessType>
    ) => {
      state.transactions = state.transactions.concat(action.payload.items);
      state.seeMore = action.payload.hasMore;
      state.offset = action.payload.offset + action.payload.limit;
      state.limit = action.payload.limit;
    },
    getTransactionsError: () => {},
    setTransactionFilters: (
      state: TransactionStateType,
      action: PayloadAction<SetFilterType>
    ) => {
      state.filters = action.payload;
    },
    resetErrorTransactions: (state: TransactionStateType) => {
      state.errorTransactions = [];
    },
    setActualRegion: (
      state: TransactionStateType,
      action: PayloadAction<string>
    ) => {
      state.filters = {
        ...state.filters,
        actualRegion: action.payload,
      };
    },
    setActualWorkzone: (
      state: TransactionStateType,
      action: PayloadAction<string>
    ) => {
      state.filters = {
        ...state.filters,
        actualWorkzone: action.payload,
      };
    },
    setExportEnabled: (
      state: TransactionStateType,
      action: PayloadAction<string | number | undefined>
    ) => {
      state.exportDisabled = action.payload === undefined;
    },
    getTransactionsExportRequest: (
      state: TransactionStateType,
      action: PayloadAction<FilterTransactionsType>
    ) => {},
    getTransactionsExportSuccess: () => {},
    getTransactionsExportError: () => {},

    getDetailTransactionDevolutionUndeliveredSuccess: (
      state: TransactionStateType
    ) => {
      state.detailTransactionModalOpen = false;
    },
    getDetailTransactionReasonsCanceledSuccess: (
      state: TransactionStateType
    ) => {
      state.detailTransactionModalOpen = false;
    },
    getDetailTransactionFinishReturnedSuccess: (
      state: TransactionStateType
    ) => {
      state.detailTransactionModalOpen = false;
    },
    getDetailTransactionFinishLostSuccess: (state: TransactionStateType) => {
      state.detailTransactionModalOpen = false;
    },
    getDetailTransactionDniDeliveredSuccess: (state: TransactionStateType) => {
      state.detailTransactionModalOpen = false;
    },
    getCloseModalDetailTransaction: (state: TransactionStateType) => {
      state.detailTransactionModalOpen = false;
    },
    postCancelTransactionsRequest: (
      state: TransactionStateType,
      action: PayloadAction<BulkCancelTransactionType>
    ) => {},
    postCancelTransactionsSuccess: (state: TransactionStateType) => {
      state.masiveCancelationModalOpen = false;
    },
    postCancelTransactionsError: (
      state: TransactionStateType,
      action: PayloadAction<any>
    ) => {
      state.errorTransactions = action.payload.data.message;
    },
    toggleDetailTransactionModal: (
      state: TransactionStateType,
      action: PayloadAction<boolean>
    ) => {
      state.detailTransactionModalOpen = action.payload;
    },
    toggleMasiveCancelationModal: (
      state: TransactionStateType,
      action: PayloadAction<boolean>
    ) => {
      state.masiveCancelationModalOpen = action.payload;
    },
    toggleItem: (
      state: TransactionStateType,
      action: PayloadAction<TransactionResponseTypeResult>
    ) => {
      const item = action.payload;
      const idx = state.transactionsSelected.findIndex(
        (p) => p.transaction.id === item.transaction.id
      );
      if (idx >= 0) state.transactionsSelected.splice(idx, 1);
      else state.transactionsSelected.push(item);
    },
    toggleAll: (state: TransactionStateType) => {
      const approvedItems = state.transactions.filter(
        (p) => p.transaction.state?.tag === "PENDING_ASSIGNMENT"
      );
      // Estan todas las preli seleccionadas
      if (approvedItems.length === state.transactionsSelected.length)
        state.transactionsSelected = [];
      else state.transactionsSelected = approvedItems;
    },
    setCollapseTable: (state, action: PayloadAction<boolean>) => {
      state.collapseTable = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(
        detailTransactionAction.getDetailTransactionSuccess.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = true;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionRequest.type,
        (state: TransactionStateType) => {}
      )
      .addCase(
        detailTransactionAction.getDetailTransactionMenssagesError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
          actions.getTransactionsRequest({
            ...state.filters,
            offset: 0,
          });
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionMenssagesRequest.type,
        (state: TransactionStateType) => {}
      )
      .addCase(
        detailTransactionAction.getDetailTransactionMenssagesSuccess.type,
        (state: TransactionStateType) => {}
      )
      .addCase(
        detailTransactionAction.getDetailTransactionReasonsCanceledError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionFinishReturnedError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionFinishLostError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionDniDeliveredError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionDevolutionUndeliveredError
          .type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      )
      .addCase(
        detailTransactionAction.getDetailTransactionError.type,
        (state: TransactionStateType) => {
          state.detailTransactionModalOpen = false;
        }
      ),
});

export const transactionsSelector = (state: RootState) => state.transactions;

export const actions = transactionSlice.actions;

export const allTransactionsSelected = (state: RootState): boolean =>
  state.transactions.transactionsSelected.length > 0 &&
  state.transactions.transactions.filter(
    (t) => t.transaction.state?.tag === "PENDING_ASSIGNMENT"
  ).length === state.transactions.transactionsSelected.length;
export const exisPendingTransactions = (state: RootState): boolean =>
  state.transactions.transactions.some(
    (t) => t.transaction.state?.tag === "PENDING_ASSIGNMENT"
  );
export default transactionSlice.reducer;
